// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__lo761","email":"Contact_email__keNDJ","title":"Contact_title__a0xQo","image":"Contact_image__MOgiu","updown":"Contact_updown__zbiVK"};